<template>
  <div class="row">
    <div class="col">
      <h3>Name</h3>
      <div class="row">
        <div class="col-9">
          <table>
            <tr>
              <td>Product</td>
              <td>{{ product }}</td>
            </tr>
            <tr>
              <td>Type</td>
              <td>{{ type }}</td>
            </tr>
            <tr>
              <td>Number of licenses on agreement</td>
              <td>{{ number_on_agreement }}</td>
            </tr>
            <tr>
              <td>Number of licenses used</td>
              <td>{{ number_used }}</td>
            </tr>
            <tr>
              <td>Agreement Date</td>
              <td>{{ agreement_date }}</td>
            </tr>
          </table>
        </div>
        <div class="col-3">
          <!-- only show if no device available -->
          <div class="alert alert-warning" v-show="!deviceInfo.device_id && !deviceInfo.product">
            <p>To claim a license, log into corpuls simulation from your corpuls simulation device.</p>
          </div>
          <!-- only show if device available and not licensed -->
          <router-link
            :to="{ name: 'my-claim', params: { contractId: contractId } }"
            class="btn btn-primary btn-block"
            v-show="deviceInfo.device_id && deviceInfo.product === product && !already_licensed"
          >Claim License</router-link>
          <!-- only show if current license agreement is where current license is from -->
          <button
            class="btn btn-secondary btn-block"
            type="submit"
            v-show="already_licensed && isCurrentDeviceLicensedFromContract()"
          >Relinquish License</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyContract",
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    }
  },
  methods: {
    isCurrentDeviceLicensedFromContract: function() {
      for (let i = 0; i < this.licenses.length; i++) {
        let license = this.licenses[i];
        if (license.device_id === deviceInfo.deviceId && !license.is_deleted) {
          return true;
        }
      }
      return false;
    }
  },
  props: {
    contractId: Number,
    name: String,
    product: String,
    type: String,
    number_on_agreement: Number,
    number_used: Number,
    agreement_date: String,
    already_licensed: Boolean,
    licenses: Array
  }
};
</script>

<style scoped></style>
